"use client";

import { BoltIcon } from "@heroicons/react/16/solid";
import { twMerge } from "tailwind-merge";
import { AUTO_POST } from "./autoPostName";

export const AUTO_POST_PUBLICATION_TOOLTIP = `Scheduled by ${AUTO_POST}`;

/** Publication ownership survives publishing, independently of the project's switch. */
export default function AutoPostPublicationMark({
  autoFolderId,
  showLabel = false,
  disableTooltip = false,
  className,
  onManage,
}: {
  autoFolderId?: string | null;
  showLabel?: boolean;
  disableTooltip?: boolean;
  className?: string;
  onManage?: () => void;
}) {
  if (!autoFolderId) return null;

  const Tag = onManage ? "button" : "span";
  const tooltip = onManage ? `Manage ${AUTO_POST}` : AUTO_POST_PUBLICATION_TOOLTIP;

  return (
    <Tag
      type={onManage ? "button" : undefined}
      role={onManage ? undefined : "img"}
      aria-label={tooltip}
      onClick={onManage ? (event) => { event.stopPropagation(); onManage(); } : undefined}
      tabIndex={disableTooltip ? undefined : 0}
      data-tooltip-id={disableTooltip ? undefined : "global"}
      data-tooltip-content={disableTooltip ? undefined : tooltip}
      className={twMerge(
        "inline-flex shrink-0 items-center gap-1 rounded text-primary outline-none focus-visible:ring-2 focus-visible:ring-ring",
        onManage && "cursor-pointer hover:bg-white hover:shadow-md transition-colors",
        className,
      )}
    >
      <BoltIcon className="size-3.5 shrink-0" aria-hidden />
      {showLabel ? <span aria-hidden className="text-xs leading-4">{AUTO_POST}</span> : null}
    </Tag>
  );
}
